import React, {
  ReactNode,
  Dispatch,
  SetStateAction,
  useState,
  useEffect,
} from 'react';
import List from '@mui/material/List';
import { Autocomplete, TextField } from '@mui/material';
import { IAreaList } from 'src/basic-rest/types';
import { AddressLoading, AddressNotFound } from './utils';
import { IGetID } from './Address';
import { useFetchAreaData } from 'src/basic-rest/useFetchAddressData';
import { Box } from '@mui/system';

type IProps = {
  checked: IGetID;
  setChecked: Dispatch<SetStateAction<IGetID>>;
};

function FilterAreaList({ checked, setChecked }: IProps) {
  const [open, setOpen] = useState(false);
  const {
    data: areaData,
    fetchAreaData,
    loading,
    setData,
  } = useFetchAreaData();

  useEffect(() => {
    if (checked?.division || checked?.district || checked?.thana) {
      fetchAreaData({
        district_id: checked?.district?.district_id,
        division_id: checked?.division?.division_id,
        thana_id: checked?.thana?.thana_id,
      });
    } else {
      fetchAreaData();
    }
  }, [checked.district, checked.division, checked.thana]);

  let content: ReactNode;
  if (loading) {
    content = <AddressLoading />;
  }
  if (!loading && areaData?.length === 0) {
    content = <AddressNotFound />;
  }
  if (areaData && !loading) {
    content = (
      <Autocomplete
        size='small'
        getOptionLabel={(option: IAreaList) => option.area_name}
        id='combo-box-demo'
        options={areaData}
        renderOption={(params: any, option: IAreaList) => (
          <Box component='li' {...params}>
            {option.area_name}
          </Box>
        )}
        renderInput={(params) => (
          <TextField {...params} label='Select area' variant='outlined' />
        )}
        onChange={(_event, value: IAreaList) => {
          setChecked({ ...checked, area: value });
        }}
      />
    );
  }

  return (
    <>
      <List
        sx={{
          width: '100%',
        }}
      >
        {content}
      </List>
    </>
  );
}

export default FilterAreaList;
